import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { SkuDcParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { SkuDcReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuDcReportGridData } from '@pages/reporting-pages/deliveries-sku-dc/types/SkuDcReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-sku-dc/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesSkuDcState {
	gridData: SkuDcReportGridData[] | null,
	dateRange: DateRange | null,
	materialId: string | null,
};

const initialState: ReportingDeliveriesSkuDcState = {
	gridData: null,
	dateRange: null,
	materialId: null,
};



export const reportingDeliveriesSkuDcSlice = createSlice({
	name: 'reportingDeliveriesSkuDc',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<SkuDcReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setMaterialId: (state, action: PayloadAction<string | null>) => {
			state.materialId = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<SkuDcParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
			if (action.payload.materialId !== state.materialId) {
				state.materialId = action.payload.materialId ? action.payload.materialId : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setMaterialId,
	setSearchParameters,
	resetStore } = reportingDeliveriesSkuDcSlice.actions;